export enum NotificationType {
  PROPOSAL = 'proposal',
  OFFER = 'offer',
  MEMBER_AREA = 'memberArea'
}
